export default __webpack_public_path__ + "static/banners_cert2-1f8c993ac9c37e4b78da906783a7f796.png";